import { CommentApi, PostApi } from "../pages/DashBoard/partials/Feed/types/types";
import { buildFeedPostUpdateFormData } from "./buildFeedPostUpdateFormData";
import { getParsedArray } from "./getParsedArray";

interface PostDataProps {
  post: PostApi;
  comment: CommentApi;
}

export const deleteCommentFormData = ({post, comment}: PostDataProps) => {
  const parsedComments: CommentApi[] = getParsedArray(post.comments);
  const updatedComments = parsedComments.filter(
    (prevComment: CommentApi) =>
      prevComment.comment_id !== comment.comment_id
  );

  return buildFeedPostUpdateFormData(post, {
    comments: JSON.stringify(updatedComments),
  });
};
